var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-icon',{attrs:{"icon":_vm.status ? 'LockIcon' : 'UnlockIcon',"tooltip":_vm.status ? _vm.$t('lock') : _vm.$t('unlock')},on:{"click":_vm.confirm}})
}
var staticRenderFns = []

export { render, staticRenderFns }